// src/components/CustomHeader.tsx
import React, { useEffect } from 'react';
import { Box, Avatar, Badge, Tooltip, } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../hooks/useAuth";
import { getUserRoleName } from '../utils/helpers';
import { AppDispatch, RootState } from '../stores';
import { fetchNotificationCount } from '../stores/notificationSlice';
import { StyledAppBar, StyledContainer, HeaderBox, NotificationIconButton, UserBox, AvatarWrapper, UserInfoBox, UserNameTypography, UserRoleTypography, } from './styles/CustomUserHeader.styles';
import NotificationModal from './UI/NotificationListModal';
import { User, Agent, SuperVisor } from '../types';
import { USER_TYPES } from '../utils/constants';
import { openDialerForUser } from '../utils/dialer';


const CustomHeader: React.FC = () => {
  const user : User | Agent | SuperVisor | null = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const count = useSelector((state: RootState) => state.notifications.count);
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  const showAgentTypeSuffix = user?.userType !== USER_TYPES.SUPER_ADMIN && user && 'agentType' in user && (user as Agent).agentType;
  const showTicketAction = user?.userType === USER_TYPES.SUPERVISOR || user?.userType === USER_TYPES.AGENT;

  useEffect(() => {
    dispatch(fetchNotificationCount());
  }, [dispatch]);


  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const notificationClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null)


  return (
    <StyledAppBar position="static" elevation={0}>
      <StyledContainer maxWidth={false} disableGutters>
        <HeaderBox>
          <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <Tooltip title="Open dialer">
              <NotificationIconButton
                className="blue"
                aria-label="Open dialer"
                onClick={() => void openDialerForUser(user, accessToken)}
              >
                <img src="/images/call-icon.svg" alt="Call" />
              </NotificationIconButton>
            </Tooltip>
            {showTicketAction && (
              <Tooltip title="Open tickets">
                <NotificationIconButton
                  className="yellow"
                  aria-label="Open tickets"
                  onClick={() => navigate('/tickets')}
                >
                  <img src="/images/email-icon.svg" alt="Msg" />
                </NotificationIconButton>
              </Tooltip>
            )}
            <NotificationIconButton
              // onClick={() => navigate('/notifications') }
              onClick={notificationClick}
            >
              <Badge badgeContent={count} color="primary">
                <img src="/images/notification-icon2.svg" alt="bell" />
              </Badge>
            </NotificationIconButton>
            <NotificationModal onClose={handleClose} anchorEl={anchorEl} />
            <UserBox onClick={() => navigate('/profile')} sx={{ cursor: 'pointer' }}>
              <AvatarWrapper>
                <Avatar
                  alt={user?.fullName || user?.userName || "User"}
                  src={(user as any)?.profileImage}
                  sx={{ width: 38, height: 38 }}
                >
                  {!(user as any)?.profileImage && (user?.fullName || user?.userName || 'U').charAt(0).toUpperCase()}
                </Avatar>
              </AvatarWrapper>
              <UserInfoBox>
                <UserNameTypography>{user?.fullName || user?.userName || "Guest"}</UserNameTypography>
                <UserRoleTypography>
                  {getUserRoleName(user)}
                  {showAgentTypeSuffix ? ` - ${(user as Agent).agentType}` : ''}
                </UserRoleTypography>
              </UserInfoBox>
            </UserBox>
          </Box>
        </HeaderBox>
      </StyledContainer>
    </StyledAppBar>
  );
};

export default CustomHeader;
